import {
  MenuButtonAddTable,
  MenuButtonAlignCenter,
  MenuButtonAlignLeft,
  MenuButtonAlignRight,
  MenuButtonBlockquote,
  MenuButtonBold,
  MenuButtonBulletedList,
  MenuButtonCode,
  MenuButtonEditLink,
  MenuButtonHighlightColor,
  MenuButtonHorizontalRule,
  MenuButtonItalic,
  MenuButtonOrderedList,
  MenuButtonRedo,
  MenuButtonTextColor,
  MenuButtonUnderline,
  MenuButtonUndo,
  MenuControlsContainer,
  MenuDivider,
  MenuSelectHeading,
} from 'mui-tiptap';

export function RichTextEditorExtensions() {
  return (
    <MenuControlsContainer>
      <MenuSelectHeading />
      <MenuDivider />

      <MenuButtonBold />
      <MenuButtonItalic />
      <MenuButtonUnderline />
      <MenuDivider />

      <MenuButtonTextColor />
      <MenuButtonHighlightColor />
      <MenuDivider />

      <MenuButtonAlignLeft />
      <MenuButtonAlignCenter />
      <MenuButtonAlignRight />
      <MenuDivider />

      <MenuButtonBulletedList />
      <MenuButtonOrderedList />
      <MenuDivider />

      <MenuButtonEditLink />
      <MenuButtonAddTable />
      <MenuDivider />

      <MenuButtonBlockquote />
      <MenuButtonCode />
      <MenuButtonHorizontalRule />
      <MenuDivider />

      <MenuButtonUndo />
      <MenuButtonRedo />
    </MenuControlsContainer>
  );
}
